import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

interface SessionTransferDialogProps {
  open: boolean
  onProceed: () => void
  onCancel: () => void
}

export function SessionTransferDialog({ open, onProceed, onCancel }: SessionTransferDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Already Logged In</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You are already logged in on another browser or device. Would you like to continue with this login and log out
          from the other session?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onProceed} color="primary" autoFocus>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  )
}
